import React from "react";
import Downshift from "downshift";
import cn from "classnames";
import { Search } from "../Icons";

function AutoCompleteRow({ highlightedIndex, index, children, ...other }) {
  const className = cn(
    "p-2 text-sm text-grey-darkest border-b border-grey-lighter",
    {
      "bg-grey-light": highlightedIndex === index,
      "bg-white": highlightedIndex !== index,
      "cursor-pointer": highlightedIndex === index
    }
  );
  return (
    <li className={className} {...other}>
      {children}
    </li>
  );
}

function AutoCompleteList({ maxHeight, children }) {
  return (
    <ul
      style={{
        maxHeight: `${maxHeight}`,
        zIndex: "40"
      }}
      className="mt-2 list-reset w-full rounded border border-grey-light overflow-y-scroll absolute p-1"
    >
      {children}
    </ul>
  );
}

export default class AutoComplete extends React.Component {
  renderItemList = ({ isOpen, getItemProps, highlightedIndex }) => {
    const { items, renderItems, maxHeight } = this.props;
    return isOpen ? (
      <AutoCompleteList maxHeight={maxHeight}>
        {items.length ? (
          items.map((item, index) => (
            <AutoCompleteRow
              key={index}
              {...getItemProps({
                key: index,
                index,
                item
              })}
              highlightedIndex={highlightedIndex}
              index={index}
            >
              {renderItems(item)}
            </AutoCompleteRow>
          ))
        ) : (
          <li className="p-4 text-sm text-grey-darker bg-white">
            Die Suche ergab keine Treffer
          </li>
        )}
      </AutoCompleteList>
    ) : null;
  };
  render() {
    const {
      itemToString,
      items,
      placeholder,
      maxHeight,
      handleFocus,
      handleBlur,
      ...other
    } = this.props;
    return (
      <Downshift
        itemToString={itemToString}
        {...other}
        render={({
          getInputProps,
          getItemProps,
          isOpen,
          selectedItem,
          highlightedIndex
        }) => (
          <div className="relative">
            <div
              className="absolute pin-t"
              style={{
                top: "3px",
                left: "15px"
              }}
            >
              <Search width="25px" />
            </div>
            <input
              className="autocomplete-input"
              style={{
                paddingLeft: "64px"
              }}
              {...getInputProps({
                placeholder,
                onFocus: ev => {
                  handleFocus(ev);
                },
                onBlur: ev => {
                  handleBlur(ev);
                }
              })}
            />
            {this.renderItemList({
              isOpen,
              getItemProps,
              highlightedIndex,
              selectedItem,
              maxHeight
            })}
          </div>
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/AutoComplete/AutoComplete.js